import { f2, totals, type Sheet } from "@ic/engine";

export function defaultSaveName(sheet: Sheet): string {
  const name = sheet.h.name.trim() || sheet.h.style.trim() || "Cost Sheet";
  const qty = sheet.h.qty.trim();
  return [name, qty ? `${qty}件` : "", `FOB $${f2(totals(sheet).fob)}`].filter(Boolean).join(" · ");
}
